import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DialogData } from 'src/app/models/dialog-data';
import { DialogComponent } from 'src/app/components/dialog/dialog.component';
import { BeFormaPagamento } from 'src/app/models/BeFormaPagamento';
import { SubService } from 'src/app/services/sub.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { ListaDadosColuna } from 'src/app/components/lista-dados/lista-dados.component';

@Component({
  selector: 'app-formas-pagamento',
  templateUrl: './list-formas-pagamento.component.html',
  styleUrls: ['./list-formas-pagamento.component.css']
})
export class ListFormasPagamentoComponent implements OnInit, OnDestroy {
  public formasPagamento: BeFormaPagamento[] = [];
  public colunasListaDados: ListaDadosColuna[] = [
    {
      campo: 'dsFormaPagamento',
      rotulo: 'Forma de Pagamento',
      tamanho: '60%',
      editavel: true,
      edicao: {
        tipoEditor: 'texto',
        validacao: {
          obrigatorio: true,
          minLength: 3,
          maxLength: 20,
        }
      }
    }
  ];
  public subscription?: Subscription;

  public constructor(
    private httpClient: HttpClient,
    private sub: SubService,
    private dialog: MatDialog,
    private snackBarService: SnackBarService,
  ) { }

  public ngOnInit(): void {
    this.subscription = this.httpClient.get<BeFormaPagamento[]>(`/api/FormasPagamento`).subscribe({
      next: (res) => {
        this.unsubscribe();
        this.formasPagamento = res ?? [];
      },
      error: (err) => {
        this.unsubscribe();
        this.snackBarService.exibirErro(`Erro! - ${err.status} - ${err.statusText}`);
      }
    });
  }

  public ngOnDestroy(): void {
    this.unsubscribe();
  }

  public onSalvarLinha(formaPagamento: BeFormaPagamento) {
    this.unsubscribe();

    const payload: any = {
      idFormaPagamento: formaPagamento.idFormaPagamento ?? null,
      dsFormaPagamento: (formaPagamento.dsFormaPagamento ?? '').trim(),
    };

    const requisicao = payload.idFormaPagamento
      ? this.httpClient.put<unknown>(`/api/FormasPagamento`, payload)
      : this.httpClient.post<BeFormaPagamento>(`/api/FormasPagamento`, payload);

    this.subscription = requisicao.subscribe({
      next: (res: any) => {
        this.unsubscribe();
        if (!payload.idFormaPagamento && res?.idFormaPagamento) {
          formaPagamento.idFormaPagamento = res.idFormaPagamento;
        }
        formaPagamento.dsFormaPagamento = payload.dsFormaPagamento;
        this.formasPagamento = [...this.formasPagamento];
        this.snackBarService.exibirSucesso(payload.idFormaPagamento ? 'Registro salvo!' : 'Registro criado!');
      },
      error: (err) => {
        this.unsubscribe();
        this.snackBarService.exibirErro(`Erro! - ${err.status} - ${err.statusText}`);
      }
    });
  }

  public onDelete(formaPagamento: BeFormaPagamento) {
    this.showDialog('Deseja excluir esse registro?', 'Alerta', 'Não', 'Sim', formaPagamento);
  }

  public showDialog(msg: string, statusMsg: string, button: string = 'OK', secondButton: string = '', formaPagamento: BeFormaPagamento = {} as BeFormaPagamento) {
    if (this.subscription)
      return;
    const dialogData: DialogData = {
      title: statusMsg,
      message: msg,
      buttonText: button,
      secondButtonText: secondButton,
    };
    const dialogRef = this.dialog.open(DialogComponent, { data: dialogData });
    dialogRef.afterClosed().subscribe((result) => {
      this.unsubscribe();
      if (result) {
        this.sub.reset(this.httpClient.delete(`/api/FormasPagamento/${formaPagamento.idFormaPagamento}`),
          () => this.onDeleteConfirm(formaPagamento),
          () => this.showDialog('Não foi possível excluir o registro!', 'Erro')
        );
      }
    })
  }

  private onDeleteConfirm(res: BeFormaPagamento) {
    this.formasPagamento = this.formasPagamento.filter(formaPagamento => formaPagamento.idFormaPagamento !== res.idFormaPagamento);
    this.snackBarService.exibirSucesso('Registro excluído!');
  }

  private unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = undefined;
    }
  }
}
